import React from 'react';
import { ThemeProvider } from '../ThemeContext';
import { rememberThemeChoice } from '../shared/themePreference';
import HomeownerPaywall from './HomeownerPaywall';
import HomeownerSignup from './HomeownerSignup';
import { annualRenewalCopy } from '../shared/homeownerRenewalMail';
import { sponsorLandingCopy } from '../shared/sponsorLandingMail';
import { homeownerNotificationShell } from '../shared/emailLayout';

function mailFrame(copy, testId) {
  const html = homeownerNotificationShell({
    title: copy.subject,
    bodyHtml: copy.paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join(''),
    agent: null,
    sentTo: 'delivered+landing@resend.dev',
  });
  return (
    <iframe
      key={testId}
      title={copy.subject}
      data-testid={testId}
      srcDoc={html}
      style={{ width: '100%', height: '720px', border: 0, background: '#ffffff', marginBottom: '1rem' }}
    />
  );
}

function LandingPreview() {
  const fields = {
    sponsorName: 'Riley Sponsor',
    firstName: 'Sam',
    periodEnd: '2026-11-26T15:00:00.000Z',
    windowEnd: '2027-01-25T15:00:00.000Z',
    daysLeft: 7,
  };
  return (
    <div data-testid="landing-email-preview" style={{ background: '#1a1a1a', minHeight: '100vh', padding: '1rem' }}>
      {mailFrame(sponsorLandingCopy('advance', fields), 'landing-advance')}
      {mailFrame(sponsorLandingCopy('end', fields), 'landing-end')}
      {mailFrame(sponsorLandingCopy('day53', fields), 'landing-day53')}
      {mailFrame(sponsorLandingCopy('deleted', fields), 'landing-deleted')}
    </div>
  );
}

function EmailPreview() {
  const copy = annualRenewalCopy({
    current_period_end: '2027-10-26T15:00:00.000Z',
  }, { last4: '4242' });
  const html = homeownerNotificationShell({
    title: copy.subject,
    bodyHtml: copy.paragraphs.map((paragraph) => `<p>${paragraph}</p>`).join(''),
    agent: null,
    sentTo: 'delivered+renewal@resend.dev',
  });
  return (
    <iframe
      title="Renewal reminder"
      data-testid="renewal-email-preview"
      srcDoc={html}
      style={{ width: '100%', height: '100vh', border: 0, background: '#1a1a1a' }}
    />
  );
}

function Screens() {
  const params = new URLSearchParams(window.location.search);
  const screen = params.get('screen') || 'paywall';
  if (screen === 'signup') {
    return <HomeownerSignup native={false} onSignedUp={() => {}} onSignIn={() => {}} />;
  }
  if (screen === 'native') {
    return <HomeownerPaywall native plan={{ reason: 'unpaid', entitled: false }} />;
  }
  if (screen === 'email') return <EmailPreview />;
  if (screen === 'landing') return <LandingPreview />;
  if (screen === 'status') {
    return (
      <HomeownerPaywall
        page
        native={false}
        plan={{ reason: 'sponsored', entitled: true }}
      />
    );
  }
  if (screen === 'cancel') {
    return (
      <HomeownerPaywall
        native={false}
        plan={{
          reason: 'sponsorless_paid',
          entitled: true,
          subscriptionOpen: true,
          portal: true,
          planStatus: 'active',
          planInterval: 'month',
          currentPeriodEnd: '2026-11-26T15:00:00.000Z',
          cancelAtPeriodEnd: false,
        }}
        startCheckout={async () => ({ cancelAtPeriodEnd: true, currentPeriodEnd: '2026-11-26T15:00:00.000Z' })}
      />
    );
  }
  return (
    <HomeownerPaywall
      native={false}
      plan={{ reason: 'unpaid', entitled: false, portal: false, annualEnabled: params.get('annual') === '1' }}
      startCheckout={async () => ({})}
    />
  );
}

export default function HomeownerBillingPreview() {
  const params = new URLSearchParams(window.location.search);
  const theme = params.get('theme') === 'dark' ? 'dark' : 'light';
  try {
    rememberThemeChoice(localStorage, theme === 'dark');
  } catch (error) {
    // Preview still renders with the stored theme.
  }
  return (
    <ThemeProvider>
      <Screens />
    </ThemeProvider>
  );
}
